
import "@/share/header"
import "@/share/footer"
import "@/share/styles/common.less";
import "@/share/styles/components/container.less";
import "@/share/styles/components/layout.less";
import "@/share/styles/header.less";
import "@/share/popover";
import { usePlayVideo } from "@/share/play-video";
import { lazyLoad } from "@/lib/lazyLoad";
import { ready } from "@/lib/ready";
import { aptip } from "@/lib/tooltip";
import Broweser from "@/lib/browser";
import { loadCSS } from "@/lib/loadCSS";
import { loadJq } from "@/lib/loadJq";
import { loadJs } from "@/lib/loadJs";
import { debounce } from "@/lib/debounce";
import { on } from "@/lib/dom/on";
import { off } from "@/lib/dom/off";
import { addClass } from "@/lib/dom/addClass";
import { removeClass } from "@/lib/dom/removeClass";
import Dialog from '@/lib/easy-dialog';


const videoUrl = (window as any).videoUrl;
const videoThumbnail = (window as any).videoThumbnail;

const { playVideo, closeVideo } = usePlayVideo(800, 660);

(window as any).openVideoZoom = () => {
  playVideo({
    videoUrl: videoUrl,
    thumbnail: videoThumbnail,
    reloadVideo: false,
  });
}

Object.assign(globalThis, {
  loadCSS: loadCSS,
  loadJq: loadJq,
  loadJs: loadJs,
  ready: ready,
  lazyLoad: lazyLoad,
  Browser: Broweser,
  debounce: debounce,
  on: on,
  off: off,
  addClass,
  removeClass,
  dialog: {
    open: Dialog.open,
    close: Dialog.close
  },
  tooltip: aptip
});